import { defineStore, acceptHMRUpdate } from 'pinia';
import utilitiesData from '../../utilities/common/data';
import LoginRepository from '../../repositories/auth/LoginRepository';

const dataChangePassword = {
  password: null,
  confirm_password: null,
};

export const useChangePasswordStore = defineStore('ChangePasswordStore', {
  state: () => ({
    isSuccess: false,
    hasErrorSingle: null,
    // form page
    formData: structuredClone(dataChangePassword),
    hasFormError: structuredClone(dataChangePassword),
    isLoadingForm: false,
  }),
  actions: {
    async changePassword() {
      try {
        this.isLoadingForm = true;
        this.isSuccess = false;
        this.resetForm(false, false);

        const params = this.formData;
        const loginSystem = await LoginRepository.changePassword(params);
        if (loginSystem.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    setFormError(error) {
      if (typeof error === 'string' || error instanceof String) {
        this.hasErrorSingle = error;
      } else {
        Object.keys(error).forEach((item) => {
          this.hasFormError[item] = error[item][0];
        });
      }
    },
    resetForm(withContent = true, withLoading = true) {
      if (withContent) {
        this.formData = structuredClone(dataChangePassword);
      }
      this.hasFormError = structuredClone(dataChangePassword);
      this.hasErrorSingle = null;
      if (withLoading) {
        this.isLoadingForm = false;
      }
    },
    removeErrorFormSingle(key) {
      this.hasFormError[key] = null;
    },
  },
  getters: {},
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useChangePasswordStore, import.meta.webpackHot));
}
